import { ALLOWED_FILE_TYPES } from "@circle-react-uikit/EmojiPickerV3/Pickers/Custom/constants";
import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";
import { useRef } from "react";

import { t } from "@/i18n-js/instance";

import { useCustomIconUpload } from "../../hooks/useCustomIconUpload";
import { getFileUploadCtaByStatus } from "./constants";

interface FileUploaderProps {
  close: () => void;
}

export const FileUploader = ({ close }: FileUploaderProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { uploadFile, status } = useCustomIconUpload({ close });
  const ctaByStatus = getFileUploadCtaByStatus();

  return (
    <div className="flex flex-col gap-2">
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={e => uploadFile(e.target?.files?.[0])}
        accept={ALLOWED_FILE_TYPES.join(",")}
      />
      <Button
        variant="outline"
        type="button"
        fullWidth
        disabled={status === "uploading"}
        onClick={() => inputRef.current?.click()}
      >
        {ctaByStatus[status]}
      </Button>
      <div className="text-center">
        <Typography variant="label-xs" color="tertiary">
          {t("emoji_picker_v3.custom_icon.file_upload.recommended_size")}
          <br />
          {t("emoji_picker_v3.custom_icon.file_upload.file_types")}
        </Typography>
      </div>
    </div>
  );
};
